import { useState } from "react";
import { checklistItems } from "../data";

export default function Checklist() {
  const [checked, setChecked] = useState<boolean[]>(() =>
    checklistItems.map(() => false)
  );

  const done = checked.filter(Boolean).length;

  const toggle = (idx: number) =>
    setChecked((prev) => prev.map((v, i) => (i === idx ? !v : v)));

  const percent = Math.round((done / checklistItems.length) * 100);

  return (
    <section id="checklist" className="scroll-mt-20 bg-background-50">
      <div className="site-container py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 md:gap-8">
          <div className="lg:col-span-2 flex flex-col">
            <span className="eyebrow text-primary-600">
              <i className="ri-checkbox-circle-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              清醒吃瓜 · 自查清单
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl leading-snug text-foreground-950">
              点一点，测一测你的
              <span className="text-accent-600">「防塌」</span>
              段位
            </h2>
            <p className="mt-4 text-sm md:text-[15px] leading-relaxed text-foreground-600">
              逐条勾选你最真实的日常状态，诚实作答即可。清单不是评判，而是帮你看清自己与偶像之间，
              到底是一种健康的欣赏，还是可能让你受伤的依赖。
            </p>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-100/70 p-5">
              <div className="flex items-center justify-between">
                <p className="text-sm font-semibold text-foreground-800">当前完成度</p>
                <p className="font-serif text-2xl font-black text-primary-600">
                  {done}
                  <span className="text-sm text-foreground-500"> / {checklistItems.length} 项</span>
                </p>
              </div>
              <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-background-300">
                <div
                  className="h-full rounded-full bg-accent-500 transition-all duration-500"
                  style={{ width: `${percent}%` }}
                ></div>
              </div>
              <p className="mt-3 text-xs text-foreground-500">
                {done === checklistItems.length
                  ? "恭喜，你已经是一位足够清醒、有边界的资深吃瓜人。"
                  : done >= checklistItems.length / 2
                  ? "不错，理性框架已经成型，再核对剩下几项就更稳了。"
                  : "没关系，这正说明你值得被提醒——从第一项开始慢慢建立边界吧。"}
              </p>
            </div>

            <a
              href="#faq"
              className="mt-5 inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              还有疑问？看常见问题
              <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            </a>
          </div>

          <ul className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 self-start">
            {checklistItems.map((item, i) => {
              const on = checked[i];
              return (
                <li key={item.title}>
                  <button
                    type="button"
                    role="checkbox"
                    aria-checked={on}
                    onClick={() => toggle(i)}
                    className={`flex w-full items-start gap-3 rounded-lg border p-4 text-left transition-colors cursor-pointer ${
                      on
                        ? "border-accent-400 bg-accent-50"
                        : "border-background-200 bg-background-50 hover:border-secondary-300"
                    }`}
                  >
                    <span
                      className={`mt-0.5 flex items-center justify-center w-5 h-5 rounded-md border transition-colors shrink-0 ${
                        on
                          ? "border-accent-500 bg-accent-500 text-background-50"
                          : "border-background-300 bg-background-100"
                      }`}
                    >
                      {on ? (
                        <i className="ri-check-line text-xs w-3 h-3 flex items-center justify-center" aria-hidden="true"></i>
                      ) : null}
                    </span>
                    <span>
                      <span
                        className={`block text-sm font-semibold leading-snug ${
                          on ? "text-foreground-800 line-through decoration-accent-400" : "text-foreground-900"
                        }`}
                      >
                        {item.title}
                      </span>
                      <span className="mt-1 block text-xs leading-relaxed text-foreground-500">{item.desc}</span>
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}